import { RecentlyViewed } from '@theme/recently-viewed-products';

class ClogRecentlyViewed extends HTMLElement {
  connectedCallback() {
    this.#load();
  }

  async #load() {
    const currentId = String(this.dataset.productId || '');
    const limit = Number(this.dataset.maxProducts || 4);
    const ids = RecentlyViewed.getProducts()
      .map((id) => String(id))
      .filter((id) => id && id !== currentId)
      .slice(0, limit);

    if (!ids.length) {
      this.hidden = true;
      return;
    }

    const searchUrl = Theme?.routes?.search_url || '/search';
    const url = new URL(searchUrl, window.location.origin);
    url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('type', 'product');
    url.searchParams.set('section_id', 'recently-viewed-products');

    try {
      const response = await fetch(url);
      if (!response.ok) {
        this.hidden = true;
        return;
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const remoteItems = [...doc.querySelectorAll('[data-clog-rv-grid] [data-product-id]')];
      const ordered = ids
        .map((id) => remoteItems.find((item) => String(item.dataset.productId) === id))
        .filter(Boolean);

      const grid = this.querySelector('[data-clog-rv-grid]');
      if (!grid || !ordered.length) {
        this.hidden = true;
        return;
      }

      grid.replaceChildren(...ordered);
      this.hidden = false;
    } catch (error) {
      this.hidden = true;
    }
  }
}

if (!customElements.get('clog-recently-viewed')) {
  customElements.define('clog-recently-viewed', ClogRecentlyViewed);
}
